module.exports = __webpack_public_path__ + "static/media/ee_desk_r.b28b6d06.png";